package link.erpango.quip.data.remote

import io.ktor.client.HttpClient
import kotlinx.serialization.json.Json
import link.erpango.quip.data.remote.ktor.IApiClient
import link.erpango.quip.data.remote.ktor.RestConsumer


abstract class ApiClient(

    var urlResolver: IApiUrlResolver,
    val httpClient: HttpClient

): IApiClient {

    private val oldUrlResolver = urlResolver

    open val json =
        Json {
            encodeDefaults = false
            isLenient = true
            ignoreUnknownKeys = true
            coerceInputValues = true
            explicitNulls = false
            useArrayPolymorphism = true
        }

    open fun consume(url:String): RestConsumer {
        return RestConsumer(this, url)
    }

    open fun consume(url:String, jsonAlt: Json): RestConsumer {
        return RestConsumer(this, url, jsonAlt)
    }

    fun modifyBaseUrl(newUrl: String) {
        urlResolver = object: IApiUrlResolver {
            override val baseUrl = newUrl
        }
    }

    fun restoreBaseUrl() {
        urlResolver = oldUrlResolver
    }

    abstract val headers: Map<String, String>
}
